var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImageIcon = function SvgImageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5,
    width: 42,
    height: 38,
    rx: 7,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.544 41.456 13.193-13.193c.792-.792 1.188-1.188 1.645-1.337a2 2 0 0 1 1.236 0c.457.149.853.545 1.645 1.337l13.105 13.105M28 30l5.737-5.737c.792-.792 1.188-1.188 1.645-1.337a2 2 0 0 1 1.236 0c.457.149.853.545 1.645 1.337L44 30M20 18a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-6.4 24h20.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C44 37.44 44 35.76 44 32.4V15.6c0-3.36 0-5.04-.654-6.324a6 6 0 0 0-2.622-2.622C39.44 6 37.76 6 34.4 6H13.6c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C4 10.56 4 12.24 4 15.6v16.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C8.56 42 10.24 42 13.6 42Z",
    stroke: "#848A97",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgImageIcon;